

































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import UserQuestion from '../../../api/v2/models/user_question'
import User from '../../models/user'
import { checkMobile } from '../../utils/utils'
import Simplemde from '../atoms_molecules/Simplemde.vue'

@Component({
  components: {
    Simplemde
  }
})
export default class QuestionList extends Vue {
  @Prop({ required: true }) questions: UserQuestion[]
  isLoading: boolean = true

  relaticeObject(userQuestion: UserQuestion) {
    if (userQuestion.questionRelatives.length > 0) {
      return `${this.stringTruncate(userQuestion.relativeCourse, 10)} > ${this.stringTruncate(userQuestion.relativeLesson, 10)}`
    } else {
      return ""
    }
  }
  stringTruncate(str, length){
    if (checkMobile()){
      var dots = str.length > length ? '...' : '';
      return str.substring(0, length) + dots;
    } else {
      return str
    }
  };
}
